<template>
  <div class="feed-item">
    <div
      class="ad-wrapper"
      v-if="
        feed.type === FEED_TYPES.IMAGE_AD || feed.type === FEED_TYPES.VIDEO_AD
      "
    >
      <div class="header-wrapper">
        <AdHeader :advertise="feed" :scene="feedScene" />
      </div>
      <div class="body-wrapper">
        <div class="ad-media">
          <ImgAdElement
            v-if="feed.type === FEED_TYPES.IMAGE_AD"
            :advertise="feed"
            :scene="feedScene"
          />
          <VideoAdElement
            v-if="feed.type === FEED_TYPES.VIDEO_AD"
            :advertise="feed"
            :scene="feedScene"
          />
        </div>
        <div class="ad-content">
          {{ initAdContent }}
          <a class="ad-detail-btn" href="javascript:;" @click="viewAdDetail"
            >查看详情</a
          >
        </div>
      </div>
    </div>
    <div v-else class="feed-wrapper">
      <div class="header-wrapper">
        <FeedHeader :feed="feed" :headScene="headScene" />
      </div>
      <div class="body-wrapper">
        <div class="feed-body">
          <div class="feed-title ellipsise">{{ initFeedTitle }}</div>
          <div class="feed-summary">{{ cutOutContent }}</div>
          <div class="link-wrapper">
            <a href="javascript:;" @click="viewDetail">查看详情</a>
          </div>
          <ArticleElement v-if="isCommonArticle" :feed="feed" />
          <AlbumElement v-if="feed.article === FEED_TYPES.ALBUM" :feed="feed" />
          <AudioElement v-if="feed.article === FEED_TYPES.AUDIO" :feed="feed" />
          <VideoElement v-if="feed.article === FEED_TYPES.VIDEO" :feed="feed" />
          <AdminVideoElement v-if="isAdminVideo" :feed="feed" />
        </div>
      </div>
      <div class="footer-wrapper">
        <FeedFooter :feed="feed" :headScene="headScene" />
      </div>
    </div>
  </div>
</template>
<script>
import FeedHeader from "./feed-header";
import AdHeader from "./ad-header";
import FeedFooter from "./feed-footer";
import ArticleElement from "./feed-elements/article-element";
import AdminVideoElement from "./feed-elements/admin-video-element";
import AlbumElement from "./feed-elements/album-element";
import AudioElement from "./feed-elements/audio-element";
import VideoElement from "./feed-elements/video-element";
import ImgAdElement from "./feed-elements/image-ad-element";
import VideoAdElement from "./feed-elements/video-ad-element";
import { sliceFeedContent, htmlFilter, isInternetUrl } from "../../utils/feed";
export default {
  name: "feed-item",
  data() {
    return {
      feedScene: "feedList",
    };
  },
  props: {
    feed: {
      type: Object,
      required: true,
    },
    headScene: String,
  },
  components: {
    FeedHeader,
    AdHeader,
    FeedFooter,
    ArticleElement,
    AlbumElement,
    AudioElement,
    VideoElement,
    ImgAdElement,
    VideoAdElement,
    AdminVideoElement,
  },
  computed: {
    initFeedTitle() {
      return htmlFilter(this.feed.title);
    },
    cutOutContent() {
      return sliceFeedContent(this.feed.content);
    },
    initAdContent() {
      return sliceFeedContent(this.feed.content);
    },
    isCommonArticle() {
      var typeArr = [1];
      if (
        typeArr.includes(this.feed.article) &&
        !isInternetUrl(this.feed.craw_uri)
      ) {
        return true;
      }
      return false;
    },
    isAdminVideo() {
      if (this.feed.userType == 2 && isInternetUrl(this.feed.craw_uri)) {
        return true;
      }
      return false;
    },
  },
  // watch: {
  //   feed: {
  //     handler(newValue) {
  //       console.log(newValue);
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    viewDetail() {
      if (this.headScene == "community") {
        // this.$router.push({
        //   path: "detail",
        //   query: { feedID: this.feed.modelId, feedType: this.feed.article },
        // });
        let routerClanCard = this.$router.resolve({
          path: "detail",
          query: { feedID: this.feed.modelId, feedType: this.feed.article },
        });
        window.open(routerClanCard.href, "_blank");
      } else {
        this.$message({
          message: "请先登录",
          duration: 1500,
          offset: 230,
        });
      }
    },
    viewAdDetail() {
      // this.$router.push({ path: "adDetail", query: { id: this.feed.id } });
      let routerClanCard = this.$router.resolve({
        path: "adDetail",
        query: { id: this.feed.id },
      });
      console.log(routerClanCard);
      window.open(routerClanCard.href, "_blank");
    },
  },
};
</script>
<style scoped>
.feed-item {
  margin-bottom: 15px;
  padding: 15px;
  background-color: #fff;
}

.feed-body {
  margin-left: 55px;
}

.feed-title {
  max-width: 450px;
  line-height: 30px;
  font-weight: bold;
  font-size: 16px;
}

.feed-summary {
  width: 560px;
  line-height: 25px;
  font-size: 16px;
  white-space: pre-wrap;
}

.link-wrapper a {
  color: #1a70db;
}

.ad-content {
  position: relative;
  padding: 0 5px;
  line-height: 20px;
}

.ad-content .ad-detail-btn {
  position: absolute;
  padding: 0 10px;
  bottom: 0;
  right: 8px;
  cursor: pointer;
  color: #0096e6;
  background-color: #fff;
}
</style>